<script setup>
import { computed, onMounted, ref } from 'vue';

const props = defineProps({
    to: {
        type: [String, Object],
        default: '#app-teleports',
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});

const mounted = ref(false);

const teleportTarget = computed(() => {
    if (props.disabled || typeof document === 'undefined' || typeof props.to !== 'string') {
        return props.to;
    }

    return document.querySelector(props.to) ? props.to : 'body';
});

onMounted(() => {
    mounted.value = true;
});
</script>

<template>
    <Teleport v-if="mounted || disabled" :to="teleportTarget" :disabled="disabled">
        <slot />
    </Teleport>
</template>